const TARGET_CURRENCY = 'UYU';
const FALLBACK_RATES = {
  USD: 1,
  EUR: 0.92,
  UYU: 40,
};

function shopifyConvert(amount, from, to) {
  if (typeof window.Currency?.convert !== 'function') return null;
  try {
    const converted = window.Currency.convert(amount, from, to);
    return Number.isFinite(converted) ? converted : null;
  } catch (error) {
    return null;
  }
}

function convertCents(cents, from, to, usdToUyu) {
  const amount = Number(cents);
  if (!Number.isFinite(amount)) return null;

  const live = shopifyConvert(amount, from, to);
  if (live != null) return live;

  if (from === 'USD' && to === TARGET_CURRENCY) {
    const rate = Number(usdToUyu);
    if (Number.isFinite(rate) && rate > 0) return amount * rate;
  }

  const fromRate = FALLBACK_RATES[from];
  const toRate = FALLBACK_RATES[to];
  if (!fromRate || !toRate) return null;
  return (amount * toRate) / fromRate;
}

function formatUyu(cents) {
  const major = Math.round(Number(cents) / 100);
  if (!Number.isFinite(major)) return null;
  return major.toLocaleString('es-UY', { maximumFractionDigits: 0 });
}

function fill(element) {
  if (!(element instanceof HTMLElement)) return;

  const from = element.dataset.currency || 'USD';
  if (from === TARGET_CURRENCY) {
    element.remove();
    return;
  }

  const usdToUyu = element.dataset.usdToUyu;
  const minCents = convertCents(element.dataset.priceCents, from, TARGET_CURRENCY, usdToUyu);
  if (minCents == null) return;

  let formatted = formatUyu(minCents);
  if (!formatted) return;

  const maxRaw = element.dataset.priceMaxCents;
  if (maxRaw && maxRaw !== element.dataset.priceCents) {
    const maxCents = convertCents(maxRaw, from, TARGET_CURRENCY, usdToUyu);
    const maxFormatted = formatUyu(maxCents);
    if (maxFormatted) formatted = `${formatted} - ${maxFormatted}`;
  }

  const template = element.dataset.template || 'Aprox. __PRICE__ UYU';
  element.textContent = template.replace('__PRICE__', formatted);
  element.hidden = false;
  element.dataset.converted = 'true';
}

function convertAll(root = document) {
  root.querySelectorAll('.ml_class-price-uyu-approx:not([data-converted])').forEach(fill);
}

function observe() {
  if (!document.body) return;

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('.ml_class-price-uyu-approx')) {
          fill(node);
        } else {
          convertAll(node);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

function whenCurrencyReady(callback) {
  if (typeof window.Currency?.convert === 'function') {
    callback();
    return;
  }

  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    if (typeof window.Currency?.convert === 'function' || attempts >= 20) {
      clearInterval(timer);
      callback();
    }
  }, 100);
}

function init() {
  observe();
  whenCurrencyReady(convertAll);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
